<template lang="html">
  <div
    class="user-new"
    v-if="isAdmin">
    <a
      href="#"
      class="btn btn-primary button-add-user"
      @click.prevent="newUserModal">Convidar novo usuário</a>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      ref="newUserModal"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Convidar novo usuário</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <form
              ref="newUserForm"
              class="new-user-form"
              @keydown.enter.prevent="inviteNewUser">
              <div
                v-if="error"
                class="alert alert-danger text-center"
                role="alert">
                <span v-html="error.message" />
              </div>
              <div class="form-group">
                <div
                  class="input-group new-user-email"
                  title="Email do novo usuário"
                  data-toggle="tooltip"
                  data-placement="top">
                  <div class="input-group-prepend">
                    <i class="input-group-text ik ik-at-sign" />
                  </div>
                  <input
                    type="email"
                    ref="userEmail"
                    class="form-control"
                    id="email"
                    placeholder="Email"
                    v-model="email"
                    required>
                </div>
              </div>
              <div class="form-group">
                <div
                  class="input-group new-user-password"
                  title="Senha do novo usuário"
                  data-toggle="tooltip"
                  data-placement="top">
                  <div class="input-group-prepend">
                    <i class="input-group-text ik ik-lock" />
                  </div>
                  <input
                    id="password"
                    type="password"
                    class="form-control"
                    placeholder="Senha"
                    autocomplete="new-password"
                    v-model="password"
                    required>
                  <div class="input-group-append">
                    <a
                      class="input-group-text"
                      href="#"
                      @click.prevent="togglePasswordVisibility()">
                      <i class="ik ik-eye" />
                    </a>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div
                  class="input-group new-user-role"
                  title="Tipo de acesso do novo usuário"
                  data-toggle="tooltip"
                  data-placement="top">
                  <div class="input-group-prepend">
                    <i class="input-group-text ik ik-user-check" />
                  </div>
                  <select
                    class="form-control"
                    id="role"
                    v-model="role">
                    <option value="USER">
                      Usuário
                    </option>
                    <option value="ADMIN">
                      Administrador
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Cancelar</button>
              <button
                type="button"
                class="btn btn-primary button-invite-new-user"
                ref="submitButton"
                @click.prevent="inviteNewUser">Convidar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="newUserSuccess"
      ref="newUserSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Novo usuário convidado com sucesso!</h5>
            <button
              type="button"
              class="close"
              @click.prevent="closeNewUserSuccessModal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div
              class="alert alert-warning"
              role="alert">
              O novo usuário precisa acessar o <b>link de confirmação</b> que foi enviado para o email {{ email }}
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click.prevent="closeNewUserSuccessModal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { EventBus } from '@/services/event-bus'

export default {
  name: 'UsersNew',
  data () {
    return {
      error: null,
      email: null,
      password: null,
      role: 'USER'
    }
  },
  mounted () {
    this.$nextTick(() => {
      EventBus.$on('open-add-user-modal', _ => {
        this.newUserModal()
      })
    })
  },
  methods: {
    newUserModal () {
      this.error = null
      this.$refs.newUserForm.reset()
      setTimeout(_ => {
        this.$refs.userEmail.focus()
      }, 1000)
      $(this.$refs.newUserModal).modal('show')
    },
    closeNewUserSuccessModal () {
      $(this.$refs.newUserSuccess).modal('hide')
    },
    inviteNewUser () {
      const form = this.$refs.newUserForm
      this.error = null
      if (form.checkValidity()) {
        this.$refs.submitButton.disabled = true
        setTimeout(_ => {
          this.$refs.submitButton.disabled = false
        }, 5000)
        loopback
          .post('/users', {
            name: this.email.split('@')[0],
            email: this.email,
            password: this.password,
            role: this.role
          })
          .then(newUser => {
            if (newUser && newUser.email) {
              $(this.$refs.newUserModal).modal('hide')
              $(this.$refs.newUserSuccess).modal('show')
              EventBus.$emit('new-user-added', newUser)
            }
          })
          .catch(err => {
            let errorMessage = 'Oops! Ocorreu algo inesperado :( porfavor entre em contato com suporte@api4com.com'
            if (err) {
              if (err.message) errorMessage = err.message
              if (err.statusCode && err.statusCode === 422) errorMessage = err.message
              if (err.details) {
                if (err.details.codes) {
                  if (err.details.codes.email && err.details.codes.email[0] === 'uniqueness') errorMessage = 'Email já cadastrado, por favor informe outro ou recupere a senha'
                }
              }
            }
            this.error = { message: errorMessage }
          })
      } else {
        this.error = {
          message: 'Você precisa informar um email e senha'
        }
      }
    },
    togglePasswordVisibility () {
      const input = $('#password')
      if (input[0].type === 'password') {
        input[0].type = 'text'
      } else {
        input[0].type = 'password'
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Users/New.vue